import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";
import { AssetState } from "./state";

const defaultState: AssetState = {
  assets: [],
};

export const assetsModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
